/* eslint-disable */
const
  // HEX
  HEX_ACTIVE_GREEN = exports.HEX_ACTIVE_GREEN = '#28BD52',
  HEX_INACTIVE_GREY = exports.HEX_INACTIVE_GREY = '#646777',
  HEX_APP_BLUE = exports.HEX_APP_BLUE = '#4065a0';


// WEBPACK FOOTER //
// ./src/constants/colors.js